module.exports = __webpack_public_path__ + "img/eat-da-burger.02ed1f5d.jpg";